<template>
    <div>
        <div class="container-fluid mt-2 mb-5">
            <div class="row">
                <div class="col-md-12">
                    <h3><span class="material-icons md-24 text-main-gradient">inventory</span> Paquetes Contratados</h3>
                </div>
            </div>
            <div class="row mt-4">
                <div class="col-md-4 mb-4" v-for="paquete in paquetes" :key="paquete.contrato_id">
                    <div :class="['card h-100', paquete.activo ? 'animated-card' : 'inactive-card']">
                        <div class="card-body d-flex flex-column">
                            <h5 class="text-center mb-2 ">{{ paquete.paquete_nombre }}</h5>
                            <h2 class="text-center fw-bold mb-3"> {{ paquete.paquete_costo | currency }} mxn</h2>
                            <ul class="list-unstyled mt-3 mb-4 text-center text-muted">
                                <li><span class="fw-bold">⏳ Duración:</span> {{ paquete.paquete_duracion }} días</li>
                                <li><span class="fw-bold">📅 Inicio:</span> {{ paquete.fecha_inicio | formatDate }}</li>
                                <li><span class="fw-bold">⏰ Fin:</span> {{ paquete.fecha_fin | formatDate }}</li>
                                <li><span class="fw-bold">🗓️ Días restantes:</span> {{ calculateRemainingDays(paquete.fecha_fin) }}</li>
                                <li><span class="fw-bold">Estado:</span> <span v-if="paquete.activo">✅ Activo</span><span v-else>❌ Inactivo</span></li>
                            </ul>
                            <div class="mt-auto text-center">
                                <vs-button 
                                    v-if="paquete.activo && calculateRemainingDays(paquete.fecha_fin) <= 30 && calculateRemainingDays(paquete.fecha_fin) > 0" 
                                    @click="mostrarPaquetesRenovacion(paquete)" 
                                    color="rgb(59,222,200)" 
                                    gradient
                                    block
                                >
                                    Renovar 🔄
                                </vs-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-4" v-if="todosInactivos">
                <div class="col-md-12">
                    <router-link to="/seleccionar-paquete">
                        Seleccionar un paquete
                    </router-link>
                </div>
            </div>
        </div>

        

        <!-- Modal for selecting a new package -->
        <vs-dialog v-model="showRenewDialog" title="Seleccionar Nuevo Paquete" class="custom-dialog">
            <div class="container">
                <div class="row">
                    <div class="col-md-6" v-for="paquete in paquetesDisponibles" :key="paquete.id">
                        <div class="card  mb-4 h-100 d-flex flex-column">
                            <h5 class="card-title mt-5 text-center">{{ paquete.nombre }}</h5>
                            <h2 class="text-center fw-bold">{{ paquete.costo | currency }} mxn/{{ paquete.duracion_dias > 30 ? 'año' : 'mes' }}</h2>
                            <p class="text-left" v-html="paquete.descripcion"></p>
                            <div class="mt-auto text-center">
                                <vs-button 
                                    :disabled="isProcessing" 
                                    @click="procesarRenovacion(paquete)" 
                                    color="rgb(59,222,200)" 
                                    gradient 
                                    block>
                                    Seleccionar 🚀
                                </vs-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </vs-dialog>
    </div>
</template>

<script>
    import axios from 'axios';
    import { loadStripe } from '@stripe/stripe-js';
import { stripLow } from 'validator';
    var config = require("@/config/api.json");
    const API = config.api;

    export default {
        name: "Paquetes",
        data() {
            return {
                currentUser: null,
                paquetes: [], // List of packages
                paquetesDisponibles: [], // Available packages for renewal
                paqueteSeleccionado: null, // Selected package for renewal
                showRenewDialog: false, // Controls the visibility of the renewal dialog
                isProcessing: false, // Controls the processing state
                stripe: null // Stripe instance
            };
        },
        computed: {
            todosInactivos() {
                return this.paquetes.length > 0 && this.paquetes.every(p => !p.activo);
            }
        },
        async mounted() {
            try {
                const user = JSON.parse(localStorage.getItem('user'));
                if (user) {
                    this.currentUser = user;
                    this.fetchPaquetes();
                    this.stripe = await loadStripe('pk_live_dew8vb1PPIgiCo7OYa78SdyS');
                }
            } catch (error) {
                console.error('Error loading user from localStorage:', error);
            }
        },
        methods: {
            async fetchPaquetes() {
                try {
                    const response = await axios.get(`${API}/recuperar-paquetes`, {
                        params: {
                            personal_medico_id: this.currentUser?.mainId
                        }
                    });

                    if (response.data.status === 'success') {
                        console.log('Paquetes disponibles:', response.data.data);

                        this.paquetes = response.data.data; // Assign packages
                    } else {
                        this.notify('error', 'Error al obtener los paquetes');
                    }
                } catch (error) {
                    console.error('Error al obtener los paquetes:', error);
                    this.notify('error', `Error: ${error.message}`);
                }
            },
            async mostrarPaquetesRenovacion(paquete) {
                this.paqueteSeleccionado = paquete;
                try {
                    const response = await axios.get(`${API}/listar_paquetes`);
                    if (response.data.status === 'success') {
                        this.paquetesDisponibles = response.data.data;
                        this.showRenewDialog = true;
                    } else {
                        this.notify('error', 'Error al obtener los paquetes disponibles');
                    }
                } catch (error) {
                    console.error('Error al obtener los paquetes disponibles:', error);
                    this.notify('error', `Error: ${error.message}`);
                }
            },
            async procesarRenovacion(paqueteNuevo) {
                this.isProcessing = true;
                try {
                    const diasRestantes = this.calculateRemainingDays(this.paqueteSeleccionado.fecha_fin);

                    const response = await axios.post(`${API}/crear-sesion-renovar`, {
                        nombre: paqueteNuevo.nombre,
                        costo: paqueteNuevo.costo,
                        duracion_dias: paqueteNuevo.duracion_dias,
                        paquete_id: paqueteNuevo.id,
                        personal_medico_id: this.currentUser.mainId,
                        customer_email: this.currentUser.email,
                        paquete_id_anterior: this.paqueteSeleccionado.paquete_id,
                        dias_restantes: diasRestantes > 0 ? diasRestantes : 0
                    });

                    const sessionId = response.data.id;
                    const result = await this.stripe.redirectToCheckout({ sessionId });

                    if (result.error) {
                        alert(result.error.message);
                    }
                } catch (error) {
                    console.error('Error al procesar la renovación:', error);
                    this.notify('error', `Error: ${error.message}`);
                } finally {
                    this.isProcessing = false;
                }
            },
            calculateRemainingDays(fechaFin) {
                if (!fechaFin) return 'N/A';
                const today = new Date();
                const endDate = new Date(fechaFin);
                const diffTime = endDate - today;
                const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                return diffDays > 0 ? diffDays : 0;
            }
        },
        filters: {
            currency(value) {
                return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value);
            },
            formatDate(value) {
                if (!value) return '';
                const options = { year: 'numeric', month: 'long', day: 'numeric' };
                return new Date(value).toLocaleDateString('es-MX', options);
            }
        }
    };
</script>

<style>
    .animated-card {
        transition: box-shadow 0.2s, transform 0.2s;
        box-shadow: 0 0 2px 1px rgba(0, 191, 174, 0.1);
        background-origin: border-box;
        background-clip: content-box, border-box;
        background-image: linear-gradient(360deg, #171a1e, transparent);
    }
    .animated-card:hover {
        box-shadow: 0 8px 32px 0 #171a1e, 0 1.5px 4px 0 rgba(0,0,0,0.18);
        transform: translateY(-4px) scale(1.02);
    }
    .card-title {
        letter-spacing: 0.5px;
    }
    .inactive-card {
        pointer-events: none;
        box-shadow: none !important;
        transition: none !important;
        filter: grayscale(100%);
        opacity: 0.5;
    }

    /* Dark Mode */
    body.light-mode .animated-card {
        background-image: linear-gradient(360deg, #d5fff6, transparent);
        box-shadow: 0 8px 32px 0 rgba(0,191,174,0.15), 0 1.5px 4px 0 rgba(0,0,0,0.08);
    }
    body.light-mode .animated-card:hover {
        box-shadow: 0 0 2px 1px rgba(0, 191, 174, 0.2);
    }
    body.light-mode .inactive-card {
        filter: grayscale(100%);
        opacity: 0.4;
    }

</style>
